import {
  Box,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import { customTextColor, formatArrayString } from "../../utils/const";
import styles from "./PostRequirement.module.css";
import { useEffect, useState } from "react";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { allLocation } from "../../redux/common/locationSlice";
import { useDispatch, useSelector } from "react-redux";
import { sortlistCandidate } from "../../redux/post-requirement/postRequirementSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import { allSkill } from "../../redux/common/skillSlice";

const changeCandidateStatus = (value) => {
  let status;
  if (value === "accepted") {
    status = "Accepted";
  } else if (value === "not_fit") {
    status = "Not Fit";
  } else if (value === "latter") {
    status = "Latter";
  } else if (value === "waiting") {
    status = "Waiting";
  }
  return status;
};

const BenchView = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [actionName, setActionName] = useState("");
  const [activeName, setActiveName] = useState("");

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const locations = useSelector((state) => state.location);
  const workautho = useSelector((state) => state.workautho);
  const skillData = useSelector((state) => state.skill.data);
  const requirementStatus = useSelector(
    (state) => state.postrequirement.candidateStatus
  );
  const location = useLocation();

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("postJobCandidateDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "postJobCandidateDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClickSortilistCandidate = () => {
    let userData = {
      job_id: data?.res?.job_id,
      candidate_user_id: data?.res?.candidate_resume_profile?.candidateUserId,
      candidate_email: data?.res?.candidate_resume_profile?.email,
      resume_employer_user_id:
        data?.res?.candidate_resume_profile?.recruiterUserId,
      timeline_apply_status: actionName,
    };

    let userID = data?.res?.candidate_resume_profile?.id;
    dispatch(sortlistCandidate({ userData, userID }));
  };

  useEffect(() => {
    if (requirementStatus === "change_candidate_status") {
      handleClose();
    } else if (requirementStatus === "candidate_sortlisted_succesfully") {
      // navigate("/jobpost-list-view", { state: { row: row } });
      navigate("/jobpost", { state: { row: data?.row } });
    }
  }, [requirementStatus]);

  const handleSendNow = () => {
    handleClickOpen();
  };

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
    dispatch(allSkill());
  }, [dispatch]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    console.log({ authorizationResult });

    return authorizationResult?.name;
  };

  const getSkillNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      )
      ?.filter(Boolean)
      ?.join(", ");
  };

  useEffect(() => {
    if (data) {
      setActionName(data?.res?.timeline_apply_status);
      setActiveName(data?.res?.timeline_apply_status);
    }
  }, [data]);

  const handleSelect = (text) => {
    setActionName(text);
    handleSendNow();
  };

  return (
    <>
      <Box className={styles.candidate_structure}>
        <Box
          className={styles.consultant_details}
          sx={{ backgroundColor: "#e4e6eb" }}
        >
          <span>
            <Typography sx={{ marginBottom: "15px !important" }}>
              <b>Response from Bench Sale Recruiter</b>
            </Typography>
            <Typography>
              Name :{" "}
              <b>
                {" "}
                {
                  data?.res?.candidate_resume_profile?.recruiter_details
                    ?.fullName
                }{" "}
              </b>
            </Typography>
            <Typography>
              Phone No :{" "}
              <b>
                {" "}
                {
                  data?.res?.candidate_resume_profile?.recruiter_details
                    ?.mobileNo
                }{" "}
              </b>
            </Typography>
            <Typography>
              E-Mail ID :{" "}
              <b>
                {" "}
                {
                  data?.res?.candidate_resume_profile?.recruiter_details?.email
                }{" "}
              </b>
            </Typography>
          </span>

          <a
            href={data?.res?.candidate_resume_profile?.resume}
            target="_blank"
            style={{
              textDecoration: "none",
              color: "#374151",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#d7d7d7",
                padding: "4px",
                borderRadius: "3px",
              }}
            >
              <Tooltip title="Download Resume" arrow>
                <Icon icon="pepicons-pencil:cv" height={50} width={50} />
              </Tooltip>
            </Box>
            <Typography sx={{ marginTop: "5px" }}>Open Resume</Typography>
          </a>
        </Box>

        <Grid
          container
          className={styles.profile_details_view}
          sx={{ color: customTextColor }}
        >
          <Grid
            item
            md={6}
            lg={6}
            sx={{ display: "block !important" }}
            className={styles.profile_details_views}
          >
            <ul style={{ listStyleType: "square", padding: "20px" }}>
              <Box>
                <li>
                  <Typography>
                    Candidate Name:{" "}
                    <b>{data?.res?.candidate_resume_profile?.fullName} </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Experience:{" "}
                    <b>
                      {data?.res?.candidate_resume_profile?.totalExperience}{" "}
                      {data?.res?.candidate_resume_profile?.totalExperience > 0
                        ? "Years"
                        : "Year"}
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Work Authorization:{" "}
                    <b>
                      {getWorkAuthorization(
                        data?.res?.candidate_resume_profile?.workAuthorization
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Highest Qualification:{" "}
                    <b>
                      {
                        data?.res?.candidate_resume_profile
                          ?.highestQualification
                      }
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Current Location:{" "}
                    <b>
                      {getLocationById(
                        data?.res?.candidate_resume_profile?.currentLocation
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Prefer Location:{" "}
                    <b>
                      {getPreferLocationNames(
                        data?.res?.candidate_resume_profile?.preferLocation
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Primary Skills:{" "}
                    <b>
                      {getSkillNames(
                        data?.res?.candidate_resume_profile?.skills
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>
            </ul>
          </Grid>

          <Grid
            item
            md={6}
            lg={6}
            sx={{ display: "block !important" }}
            className={styles.profile_details_views}
          >
            <ul style={{ listStyleType: "square" }}>
              <Box>
                <li>
                  <Typography>
                    Job Profile:{" "}
                    <b>
                      {data?.res?.candidate_resume_profile?.currentJobTitle}
                    </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Phone No:{" "}
                    <b>{data?.res?.candidate_resume_profile?.mobileNo}</b>
                  </Typography>
                </li>
              </Box>
              <Box>
                <li>
                  <Typography>
                    E-Mail ID:{" "}
                    <b> {data?.res?.candidate_resume_profile?.email} </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Passing Year:{" "}
                    <b> {data?.res?.candidate_resume_profile?.passingYear} </b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Billing{" "}
                    {data?.res?.candidate_resume_profile?.pTaxTeam?.includes(
                      "full_Time"
                    )
                      ? "Salary"
                      : "Rate"}
                    :{" "}
                    <b>
                      ${data?.res?.candidate_resume_profile?.rate}
                      {data?.res?.candidate_resume_profile?.pTaxTeam?.includes(
                        "full_Time"
                      )
                        ? "K Yearly"
                        : " Hourly"}
                    </b>
                  </Typography>
                </li>
              </Box>
              <Box>
                <li>
                  <Typography>
                    Tax Term:{" "}
                    <b>
                      {formatArrayString(
                        data?.res?.candidate_resume_profile?.pTaxTeam
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>
              <Box>
                <li>
                  <Typography>
                    Secondary Skills:{" "}
                    <b>
                      {getSkillNames(
                        JSON.parse(
                          data?.res?.candidate_resume_profile?.secondarySkills
                        )
                      )}
                    </b>
                  </Typography>
                </li>
              </Box>
            </ul>
          </Grid>
        </Grid>

        <Box className={styles.send_update_btns}>
          <Box className={styles.back_btns}>
            <button
              onClick={() => {
                navigate("/jobpost", { state: { row: data?.row } });

                localStorage.setItem(
                  "postJobDetails",
                  JSON.stringify({ row: data?.row })
                );
              }}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4.5px 10px ",
                backgroundColor: "#f0f2f5",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4285f4" }}
              />
            </button>
          </Box>

          <div className="btn-group">
            <button
              type="button"
              className="dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{
                color: "#fff",
                width: "7rem",
                border: "1.5px solid #4287f5",
                padding: "6px 10px",
              }}
            >
              {changeCandidateStatus(actionName)}
            </button>
            <div className="dropdown-menu">
              {/* <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("waiting")}
              >
                Waiting
              </a> */}
              <a
                className="dropdown-item"
                style={
                  activeName === "accepted"
                    ? {
                        backgroundColor: "#fff",
                        pointerEvents: "none",
                        opacity: "0.5",
                        cursor: "not-allowed ",
                      }
                    : { backgroundColor: "#fff" }
                }
                onClick={() => handleSelect("accepted")}
              >
                Accept
              </a>
              <a
                className="dropdown-item"
                style={
                  activeName === "not_fit"
                    ? {
                        backgroundColor: "#fff",
                        pointerEvents: "none",
                        opacity: "0.5",
                        cursor: "not-allowed ",
                      }
                    : { backgroundColor: "#fff" }
                }
                onClick={() => handleSelect("not_fit")}
              >
                Not Fit
              </a>
              <a
                className="dropdown-item"
                style={
                  activeName === "latter"
                    ? {
                        backgroundColor: "#fff",
                        pointerEvents: "none",
                        opacity: "0.5",
                        cursor: "not-allowed ",
                      }
                    : { backgroundColor: "#fff" }
                }
                onClick={() => handleSelect("latter")}
              >
                Latter
              </a>
            </div>
          </div>

          {/* <button onClick={handleSendNow}>Accept</button> */}
        </Box>
      </Box>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Sortlist Candidate</b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to {changeCandidateStatus(actionName)} this
            candidate
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                onClick={handleOnClickSortilistCandidate}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }} onClick={handleClose}>
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default BenchView;
